import { NoteStatusCodes } from '@oh-vcp/components-common';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import CaseService from '../services/caseService';

const useUpdateSpecialistUser = (
  specialistId: string | null,
  caseDetails: any,
  setCaseDetails: (details: any) => void,
  specialistClearRef: React.RefObject<any>
) => {
  const { providerType, statusType, caseId } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  useEffect(() => {
    const updateSpecialistUser = async () => {
      if (
        specialistId &&
        caseDetails?.programType !== 'DIRECT' &&
        caseDetails?.participant?.consultant?.userId !== specialistId
      ) {
        try {
          const updatedCaseDetails = {
            ...caseDetails,
            programType: 'DIRECT',
            participant: {
              ...caseDetails?.participant,
              statusCd: NoteStatusCodes.draft,
              consultant: {
                ...caseDetails?.participant?.consultant,
                userId: specialistId
              }
            }
          };

          setCaseDetails(updatedCaseDetails);

          await CaseService.upsertCaseDetails(updatedCaseDetails);
          queryClient.invalidateQueries(['caseDetails']);
          navigate(`/case/${providerType}/${statusType}/${caseId}`);
        } catch (error) {
          console.log(error);
        }
      }
    };
    updateSpecialistUser();
  }, [specialistId, caseDetails, setCaseDetails, specialistClearRef]);
};

export default useUpdateSpecialistUser;
